enum EntranceType {
    MasterKey = 1,
    ArrangeWithNotifier = 2
}

export default EntranceType;